import { DateTime } from 'luxon';

const TIMEZONE = 'America/New_York';

/**
 * Check if a user has a valid membership.
 * Validates: contract status is Active AND today's date (ET) is within start/end dates.
 * Uses date-only comparison so memberships are valid through the entire end date.
 */
export const isMembershipValid = (user) => {
    if (!user) return false;
    if (user.membershipContractStatus !== 'Active') return false;
    if (!user.membershipStartDate || !user.membershipEndDate) return false;

    // Get today's date in Eastern Time
    const todayET = DateTime.now().setZone(TIMEZONE).toFormat('yyyy-MM-dd');

    // Get stored dates as YYYY-MM-DD (stored as UTC midnight)
    const startDate = DateTime.fromISO(user.membershipStartDate).toUTC().toFormat('yyyy-MM-dd');
    const endDate = DateTime.fromISO(user.membershipEndDate).toUTC().toFormat('yyyy-MM-dd');

    // Valid if: startDate <= today <= endDate
    return startDate <= todayET && endDate >= todayET;
};
